// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__3lTgc","move":"styles_move__xRvqg"};